var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("DsModal", {
    attrs: {
      open: _vm.dialog,
      title: _vm.title,
      text: _vm.text,
      "primary-button-label": _vm.primaryButtonLabel,
      "secondary-button-label": _vm.secondaryButtonLabel,
      width: "600px",
    },
    on: {
      secondary: function ($event) {
        return _vm.cancelAction()
      },
      primary: function ($event) {
        return _vm.confirmAction()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }